@if (showAddToAppleWallet) {
<div [ngStyle]="buttonStyle" (click)="onClickAddToAppleWallet()" [innerHTML]="modifiedSvg | safeHtml : false"></div>
}